import React from "react";
import { Input as InputComponent, InputProps } from "antd";
import "./styles.scss";
const Input = ({ ...props }: InputProps) => {
  return <InputComponent className="sm-input" {...props} />;
};
export default Input;
